import React, { useState, useEffect } from 'react';
import {onAuthStateChanged,
signInWithEmailAndPassword} from "firebase/auth";
import {auth} from "../firebase-config";
import Alert from 'react-bootstrap/Alert';
import Cookies from 'universal-cookie';

// export default class Login extends Component {
  const Login = () => {
    const [isLoading, setLoading] = useState(false);
    const [ErrMessage, setErrMessage] = useState("");
    const [showError,setShowerror] = useState(false);

    const [LoginEmail,setLoginEmail] = useState("");
    const [LoginPassword,setLoginPassword] = useState("");
    

    useEffect(() => {
      onAuthStateChanged(auth, (currentUser) => {

        if (currentUser) {
          window.location = "/admin"
        }
        // console.log(user);
      });
      // Notice the empty dependency array, there to make sure the effect is only run once when the component mounts
    }, []);
    
    const login = async () => {
      try{
        setLoading(true);
        await signInWithEmailAndPassword(auth,LoginEmail,LoginPassword).then((res) => {
          const cookies = new Cookies();
          cookies.remove('player', { path: '/' });
          cookies.remove('player_name', { path: '/' });
          cookies.set('uid', res.user.uid, { path: '/' });
          cookies.set('email', res.user.email, { path: '/' });
          window.location = "/admin";
        });
      }catch(error){
        setErrMessage(error.message.replace("Firebase: ",""));
        setShowerror(true);
        setLoading(false);
      }
    };

    useEffect(()=>{
        if(isLoading){
            document.getElementById("data").style.display = "none";
            document.getElementById("loader").style.display = "block";
        }else{
            document.getElementById("data").style.display = null;
            document.getElementById("loader").style.display = "none";
        }
    },[isLoading]);

    useEffect(()=>{
      if(showError){
        document.getElementById("error_alert").style.display = "block";
      }else{
        document.getElementById("error_alert").style.display = "none";
      }
    },[showError]);

    return (
        <div>
          <div className="auth-wrapper" id="data">
            <div className="auth-inner">
            <h3>Sign In</h3>

            <div className="mb-3">
              <label>Email address</label>
              <input
                id="email"
                type="email"
                className="form-control"
                placeholder="Enter email"
                value={LoginEmail}
                onChange={(event)=>{setLoginEmail(event.target.value)}}
              />
            </div>

            <div className="mb-3">
              <label>Password</label>
              <input
                id='password'
                type="password"
                className="form-control"
                placeholder="Enter password"
                value={LoginPassword}
                onChange={(event)=>{setLoginPassword(event.target.value)}}
              />
            </div>

            <div className="mb-3">
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="customCheck1"
                />
                <label className="custom-control-label" htmlFor="customCheck1">
                  Remember me
                </label>
              </div>
            </div>

            <div className="d-grid">
              <button onClick={login} className="btn btn-primary">
                Sign In
              </button>
              {/* <button onClick={logout} className="btn btn-danger">
                Sign Out
              </button> */}
              <br></br>
              <Alert key="danger" variant="danger" id="error_alert">
                {ErrMessage}
              </Alert>
            </div>
            <p className="forgot-password text-right">
              Forgot <a href="/ForgotPassword">password?</a>
            </p>
        </div>
        </div>   
        <div className="loader-container" id="loader">
            <div className="loader"></div>
        </div>
      </div>
    )
}

export default Login; 